import React from 'react'
import { withRouter } from 'react-router-dom'
import Page from '../components/Page'

import '../stylesheets/pages/Welcome.scss'

class Welcome extends React.Component {
    handleNext = () => {
        this.props.history.push(`/${this.props.match.params.slug}/board/1`)
    }
    render() {
        return (
            <Page title={this.props.validation.welcome_title}>
                <div className="Welcome">
                    <div className="Welcome_holder">
                        <p>{this.props.validation.welcome_text}</p>
                        <div
                            className="Welcome_button"
                            onClick={this.handleNext}
                            style={{
                                backgroundColor: this.props.validation.button,
                                color: this.props.validation.text,
                            }}>
                            {this.props.validation.welcome_button}
                        </div>
                    </div>
                </div>
            </Page>
        )
    }
}

export default withRouter(Welcome)
